import { type FunctionComponent, type PropsWithChildren, createContext, useState } from 'react';
import { type ProductReviewsInput } from '../../__generated__/graphql-client-types';
import { INITIAL_WRITE_REVIEW_FORM_STATE } from '../../constants/reviews';
import { type WriteReviewFormInputs } from '../../helpers/product-helper/reviews/reviews.helper';

export type ReviewsContextState = {
	reviewsQueryVariables: ProductReviewsInput;
	setReviewsQueryVariables: (variables: ProductReviewsInput) => void;
	currentPage: number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	formInputsState: WriteReviewFormInputs;
	setFormInputsState: React.Dispatch<React.SetStateAction<WriteReviewFormInputs>>;
};

const initialState: ReviewsContextState = {
	reviewsQueryVariables: { familyId: 0 },
	setReviewsQueryVariables: () => {},
	currentPage: 1,
	setCurrentPage: () => {},
	formInputsState: INITIAL_WRITE_REVIEW_FORM_STATE,
	setFormInputsState: () => {}
};

type ReviewsContextProp = {
	familyId: number;
};

export const ReviewsContext = createContext<ReviewsContextState>(initialState);

export const ReviewsContextProvider: FunctionComponent<PropsWithChildren<ReviewsContextProp>> = ({ children, familyId }) => {
	const [reviewsQueryVariables, setReviewsQueryVariables] = useState<ProductReviewsInput>({ familyId });
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [formInputsState, setFormInputsState] = useState<WriteReviewFormInputs>(INITIAL_WRITE_REVIEW_FORM_STATE);

	const value = {
		reviewsQueryVariables,
		setReviewsQueryVariables,
		currentPage,
		setCurrentPage,
		formInputsState,
		setFormInputsState
	};

	return <ReviewsContext.Provider value={value}>{children}</ReviewsContext.Provider>;
};
